import { render, staticRenderFns } from "./MyPicture.vue?vue&type=template&id=286ae915&scoped=true"
import script from "./MyPicture.vue?vue&type=script&lang=js"
export * from "./MyPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ae915",
  null
  
)

export default component.exports